import { CustomAttributeViewModel } from "../customAttributeViewModel/customAttributeViewModel";

export class CustomAttributeSectionViewModel {
  id: string | undefined;
  label: string | undefined;
  index: number | undefined;
  customAttributes: CustomAttributeViewModel[] | undefined;


  constructor(payload?: any) {
    if (payload) {
      this.id = payload.id;
      this.label = payload.label;
      this.index = payload.index;
      this.customAttributes = CustomAttributeViewModel.createCustomAttributeViewModels(payload.customAttributes);
    }
  }

  /**
   * creates models from a result
   * @param result Array of any
   * @returns Bookigs
   */
  static createCustomAttributeSectionViewModels(result: Array<any>): CustomAttributeSectionViewModel[] {
    const customAttributeSectionViewModels = new Array<CustomAttributeSectionViewModel>();
    if (result) {
      result?.map((customAttributeSectionViewModel) => {
        customAttributeSectionViewModels.push(new CustomAttributeSectionViewModel(customAttributeSectionViewModel));
      });
    }
    return customAttributeSectionViewModels;
  }

}
